import { call, put, takeEvery } from 'redux-saga/effects';
import { CREATE_USER_ADDRESS_REQUEST } from '../../constants/user_address.constants';
import { createUserAddress } from '../../../requests/user_addresses_requests/create_user_addresses_request';
import { createUserAddressRequestSuccess, createUserAddressRequestFailure } from '../../actions/user_addresses_actions/common_export';
import { message_success, message_error } from '../../../../../../components/Message';

function* createUserAddressRequest({
    country, city, street, zip_code, state, user_id,
}) {
    const {
        result, options, msg, error,
    } = yield call(createUserAddress, country, city, street, zip_code, state, user_id);
    if (result) {
        yield put(createUserAddressRequestSuccess(options.person.addresses));
        message_success('New address created successfully!');
    } else {
        yield put(createUserAddressRequestFailure(error));
        message_error(msg);
    }
}

export default function* createUserAddressSaga() {
    yield takeEvery(CREATE_USER_ADDRESS_REQUEST, createUserAddressRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_addresses_sagas/create_user_address.saga.js